<template>
  <v-row class="pt-5" v-if="result">
    <v-col cols="6" offset="3">
      <v-row>
        <v-col cols="12">
          <p>User</p>
          <v-card v-if="result" light>
            <v-card-title>{{ result.doc.title }}</v-card-title>
            <v-card-text>
              <div class="preview mb-4">
                <img class="" :src="result.doc.src" />
              </div>
              <v-row>
                <v-col cols="6">
                  <h4 class="overline">Emotion</h4>
                  <p class="pa-0 mb-2 lh-0 text-h5">{{ result.doc.emotion }}</p>
                  <h4 class="overline">Super Power</h4>
                  <p class="pa-0 mb-2 lh-0 text-h5">
                    {{ result.doc.power }}
                  </p>
                </v-col>

                <v-col cols="6">
                  <h4 class="overline">Characteristics</h4>
                  <ul>
                    <li
                      v-for="(tag, index) in result.doc.attributes"
                      :key="index"
                      class="ma-1"
                    >
                      {{ tag }}
                    </li>
                  </ul></v-col
                ><v-col cols="12" v-if="result.doc.summary">
                  <p class="text-body-1" v-html="result.doc.summary"
                /></v-col>
              </v-row> </v-card-text
          ></v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsMuseumUser",
  data() {
    return {
      result: null,
      cols: 4,
    };
  },
  props: {
    uid: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise(val);
      }
    },
  },
  mounted() {
    this.getExercise(this.uid);
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getExercise(id) {
      this.doc = null;
      console.log("load doc");
      // get a ref to the exercise and listen to changes
      let ref = fb.museumExCollection.where("uid", "==", id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.result = items[0];
          }
        })
        .catch(function() {});
    },
    colorClass(val) {
      switch (val) {
        case "5":
          return "green accent-1";
        case "10":
          return "green accent-2";
        case "25":
          return "green accent-3";
        case "50":
          return "green accent-4";
      }
    },
  },
};
</script>

<style scoped="">
.preview {
  width: 100%;
  height: 30rem;
  position: relative;
  padding: 1rem;
  background: #f3f3f3;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
